export default __webpack_public_path__ + "static/index_recruit_heading-28ce80b1d34956b3a4006bb9e217a571.jpg";